import { useMemo } from "react";
import { twMerge } from "tailwind-merge";
import { SpinnerLegacy } from "../../components";
import { ORDER_BUYER } from "../../constants/routes";
import { useDiscoverySuppliersByIdsList } from "../../hooks/api/v2/discovery/useDiscoverySupplierByIdsList";
import { useNavigateToChild } from "../../hooks/useParentNavigation";
import { DiscoveryListSupplierCard } from "../discovery/v2/DiscoveryListSupplierCard";

export const EducateConnectMarket = () => {
  const navigateToChild = useNavigateToChild();
  const suppliersQuery = useDiscoverySuppliersByIdsList({
    query: [
      {
        type: "id",
        modifier: "IN",
        value: [
          220, 334, 246, 48, 201, 295, 67, 354, 118, 237, 240, 234, 386, 380,
          226, 221, 419, 177, 193, 119, 256, 280, 215, 181, 288, 291, 258, 135,
          286, 29, 224, 78, 222,
        ],
      },
    ],
  });

  const suppliers = useMemo(
    () => suppliersQuery.data?.pages.flatMap((page) => page) ?? [],
    [suppliersQuery.data],
  );

  const isLoading = suppliersQuery.isLoading;

  if (isLoading) return <SpinnerLegacy />;

  return (
    <div className="relative w-full">
      <div
        className={twMerge(
          "flex w-full flex-wrap justify-center gap-4 pb-4",
          suppliers.length > 3 &&
            "h-[500px] [scrollbar-width:none] overflow-y-scroll pb-20 [::-webkit-scrollbar]:hidden",
        )}
      >
        {suppliers.map((supplier) => (
          <DiscoveryListSupplierCard
            key={supplier.id}
            supplier={supplier}
            onClick={() =>
              navigateToChild(
                ORDER_BUYER.href({ supplierIdOrUrlId: supplier.urlId }),
              )
            }
            className="w-[calc((100%/3)-(32px/3))] min-w-[290px] flex-none"
          />
        ))}
      </div>
      {suppliers.length > 3 && (
        <div className="absolute bottom-0 left-0 h-[100px] w-full bg-linear-to-t from-zinc-100 to-transparent" />
      )}
    </div>
  );
};
